export function init() {
	const searchToggles = document.querySelectorAll('details.wp-block-details.is-style-search-toggle');

	const setupSearchToggle = function(details) {
			details.addEventListener('toggle', function(event) {
					if (!(event.target).open) {
							return;
					}
					details.querySelector('input')?.focus();
			});

			document.addEventListener('click', function(event) {
					const isClickInside = details.contains(event.target);
					if (!isClickInside && details.open) {
							details.removeAttribute('open');
					}
			}, true);
	}

	searchToggles.forEach(setupSearchToggle);
}
